module.exports = __webpack_public_path__ + "static/media/dog4.f7943fe3.jpeg";